<template>
  <!-- <a
    v-if="isPlatform('ios')"
    href="https://apps.apple.com/de/app/arag-gesundheitsapp/id1230090411"
    target="_blank"
    >App</a
  ><a
    v-else-if="isPlatform('android')"
    href="https://play.google.com/store/apps/details?id=com.ibm.de.ish.gesapp.arag.prod"
    target="_blank"
    >App</a
  ><template v-else>App</template> -->
  <a
    href="https://www.arag.de/service/kundenservice/gesundheitsapp/"
    target="_blank"
    >per App</a
  >
</template>

<script>
import { isPlatform } from "@ionic/vue";

export default {
  setup() {
    return { isPlatform };
  },
};
</script>

<style></style>
